import v1notifications from './v1notifications'

export default {
  v1notifications,
}
